import { type ChangeEvent, useRef, useState } from "react";

export function useMenuButton() {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleOpenMenu = () => setIsMenuOpen(true);
  const handleCloseMenu = () => setIsMenuOpen(false);
  const handleToggleMenu = () => setIsMenuOpen((prev) => !prev);

  const handleClickAway = (event: ChangeEvent<HTMLElement>) => {
    if (triggerRef.current && triggerRef.current.contains(event.target)) {
      return;
    }
    handleCloseMenu();
  };

  return {
    handleClickAway,
    handleCloseMenu,
    handleOpenMenu,
    handleToggleMenu,
    isMenuOpen,
    triggerRef,
  };
}
